module.exports = __webpack_public_path__ + "img/1567442348.3bef1758.jpg";